import { Button, Card, Col, Form, Row } from "antd";
import FullPageLayout from "../../../templates/FullPageLayout";
import UploadPhoto from "../../../atoms/UploadPhoto";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  DateField,
  InputField,
  InputPhone,
  SelectField,
} from "../../../atoms/FormFields";
import { createUser } from "../../Team/ducks/services";
import { AxiosError, AxiosResponse } from "axios";
import { uploadUserImage } from "../../MyProfile/ducks/services";
import { RcFile } from "antd/es/upload";
import SuccessMessage from "../../../atoms/Toasts/SuccessMessage";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "../../../atoms/Toasts/ErrorMessage";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getCompanyFormData, getCompanyFormList } from "../ducks/actions";

interface FormValues {
  first_name: string;
  last_name: string;
  first_language: string;
  email: string;
  type: string;
  phone: string;
  OfficePhoneNumber: string;
  joined_date: string;
  birthday: string;
  companyId: string;
  position_id: string;
  service_line_id: string[];
  rockstar_at: string;
}

const tempOptions = [
  { label: "Option 1", value: "Option 1" },
  { label: "Option 2", value: "Option 2" },
  { label: "Option 3", value: "Option 3" },
  { label: "Option 4", value: "Option 4" },
];

const firstLanguageOptions = [
  { label: "English", value: "english" },
  { label: "Spanish", value: "spanish" },
];

export default function CreateUser() {
  const {
    control,
    handleSubmit,
    getValues,
    trigger,
    reset,
    formState: { errors },
  } = useForm<FormValues>();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [checklistFile, setChecklistFile] = useState<File | null>(null);
  const [uploadModal, setUploadModal] = useState<boolean>(false);
  const companyList = useAppSelector((state) => state?.users?.companyFormList);
  const companyFormData = useAppSelector(
    (state) => state?.users?.companyFormData
  );
  console.log(companyFormData);
  const [previewImage, setPreviewImage] = useState<{
    file: string;
    imagePreviewUrl: string | null;
  }>({ file: "", imagePreviewUrl: null });
  const [modalPreviewImage, setModalPreviewImage] = useState<{
    file: string;
    imagePreviewUrl: string | null;
  }>({ file: "", imagePreviewUrl: null });

  const saveUpload = () => {
    setLoading(true);
    setPreviewImage({ ...modalPreviewImage });
    setLoading(false);
    setUploadModal(false);
  };

  const onSubmit = (val: FormValues) => {
    setLoading(true);
    const payload = {
      first_name: val.first_name,
      last_name: val.last_name,
      email: val.email,
      type: "client",
      phone: val?.phone ? val?.phone : undefined,
      position_id: val.position_id,
      service_line_id: val.service_line_id,
      rockstar_at: val.rockstar_at,
      first_language: val.first_language,
      joined_date: val?.joined_date ? val?.joined_date : undefined,
      birthday: val?.birthday ? val?.birthday : undefined,
      company_id: val.companyId,
    };

    createUser(payload)
      .then((res: AxiosResponse) => {
        if (checklistFile && res && res?.data?.id) {
          uploadUserImage({
            owner_id: res?.data?.id,
            image: checklistFile as File | RcFile,
            image_type: "user_image",
          })
            .then((res) => {
              if (res) {
                setLoading(false);
                SuccessMessage("User created.");
                navigate("/customer-users");
              }
            })
            .catch((e: unknown) => {
              if (e instanceof AxiosError) {
                setLoading(false);
                ErrorMessage(
                  e?.response?.data?.error?.message ?? "Something went wrong"
                );
              } else {
                setLoading(false);
                ErrorMessage("Something went wrong");
              }
            });
        } else {
          setLoading(false);
          SuccessMessage("User added.");
          navigate("/customer-users");
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  useEffect(() => {
    dispatch(getCompanyFormList());
  }, [dispatch]);

  const onChange = (value: string | number | readonly string[]) => {
    dispatch(getCompanyFormData(value as string));
  };

  const saveAddMore = async () => {
    const allValues = getValues();
    const isValid = await trigger();

    if (isValid) {
      setLoading(true);

      const payload = {
        first_name: allValues.first_name,
        last_name: allValues.last_name,
        email: allValues.email,
        type: "client",
        phone: allValues?.phone ? allValues?.phone : undefined,
        position_id: allValues.position_id,
        service_line_id: allValues.service_line_id,
        rockstar_at: allValues.rockstar_at,
        first_language: allValues.first_language,
        joined_date: allValues?.joined_date
          ? allValues?.joined_date
          : undefined,
        birthday: allValues?.birthday ? allValues?.birthday : undefined,
        company_id: allValues.companyId,
      };

      createUser(payload)
        .then((res: AxiosResponse) => {
          if (checklistFile && res && res?.data?.id) {
            uploadUserImage({
              owner_id: res?.data?.id,
              image: checklistFile as File | RcFile,
              image_type: "user_image",
            })
              .then((res) => {
                if (res) {
                  setLoading(false);
                  SuccessMessage("User created.");
                  window.location.reload();
                  reset();
                }
              })
              .catch((e: unknown) => {
                if (e instanceof AxiosError) {
                  setLoading(false);
                  ErrorMessage(
                    e?.response?.data?.error?.message ?? "Something went wrong"
                  );
                } else {
                  setLoading(false);
                  ErrorMessage("Something went wrong");
                }
              });
          } else {
            setLoading(false);
            SuccessMessage("User added.");
            window.location.reload();
            reset();
          }
        })
        .catch((e: unknown) => {
          if (e instanceof AxiosError) {
            setLoading(false);
            ErrorMessage(
              e?.response?.data?.error?.message ?? "Something went wrong"
            );
          } else {
            setLoading(false);
            ErrorMessage("Something went wrong");
          }
        });
    }
  };

  return (
    <FullPageLayout loading={loading}>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <Col className="addTeamMember">
          <div className="title">
            <h2> Create User </h2>
            <p>Complete the form below to add a user to a company.</p>
          </div>
          <Card>
            <Row gutter={20}>
              <Col>
                <h4 style={{ marginBottom: "16px" }}> Job details </h4>
              </Col>
              <Col span={24}>
                <SelectField
                  fieldName="companyId"
                  label="Company"
                  control={control}
                  selectOption={companyList}
                  iProps={{ placeholder: "Select company" }}
                  onSelectChange={onChange}
                  isRequired
                  rules={{
                    required: "Company is required.",
                  }}
                  validate={errors.companyId && "error"}
                  validMessage={errors.companyId && errors.companyId.message}
                />
              </Col>
            </Row>
            {companyFormData?.position?.length > 0 && (
              <Row gutter={20}>
                <Col span={24}>
                  <SelectField
                    fieldName="position_id"
                    label="Position"
                    control={control}
                    selectOption={companyFormData?.position}
                    iProps={{ placeholder: "Select position" }}
                    isRequired
                    rules={{
                      required: "Position is required.",
                    }}
                    validate={errors.position_id && "error"}
                    validMessage={
                      errors.position_id && errors.position_id.message
                    }
                  />
                </Col>
                <Col span={24}>
                  <SelectField
                    fieldName="service_line_id"
                    label="Service lines"
                    control={control}
                    selectOption={companyFormData?.service_line}
                    iProps={{
                      placeholder: "Select service lines",
                      mode: "multiple",
                    }}
                    tooltipTitle="Service lines managed by this employee."
                  />
                </Col>
                <Col span={24} className="mb-0">
                  <SelectField
                    fieldName="rockstar_at"
                    label="Rockstar at"
                    control={control}
                    selectOption={tempOptions}
                    iProps={{
                      placeholder: "Select rockstar at",
                      // mode: "multiple",
                    }}
                  />
                </Col>
              </Row>
            )}
          </Card>

          <Card>
            <Row gutter={20}>
              <Col span={24}>
                <h4 style={{ marginBottom: "16px" }}> Personal details </h4>
                <UploadPhoto
                  saveUpload={saveUpload}
                  loading={loading}
                  uploadModal={uploadModal}
                  setUploadModal={setUploadModal}
                  onImageDelete={() => null}
                  previewImage={previewImage}
                  checklistFile={checklistFile}
                  modalPreviewImage={modalPreviewImage}
                  setChecklistFile={setChecklistFile}
                  setPreviewImage={setPreviewImage}
                  setModalPreviewImage={setModalPreviewImage}
                  infoTextUploader="A photo helps others recognize this employee easily. It’s optional."
                  //   setIsCropModalOpen={setIsCropModalOpen}
                />
              </Col>

              <Col span={12}>
                <InputField
                  fieldName="first_name"
                  label="First name"
                  control={control}
                  defaultValue=""
                  iProps={{
                    placeholder: "Enter first name",
                    autoComplete: "first_name",
                    maxLength: 100,
                  }}
                  isRequired
                  rules={{
                    required: "First name is required.",
                  }}
                  validate={errors.first_name && "error"}
                  validMessage={errors.first_name && errors.first_name.message}
                />
              </Col>
              <Col span={12}>
                <InputField
                  fieldName="last_name"
                  label="Last name"
                  control={control}
                  defaultValue=""
                  iProps={{
                    placeholder: "Enter last name",
                    autoComplete: "last_name",
                    maxLength: 100,
                  }}
                  isRequired
                  rules={{
                    required: "Last name is required.",
                  }}
                  validate={errors.last_name && "error"}
                  validMessage={errors.last_name && errors.last_name.message}
                />
              </Col>
              <Col span={24}>
                <SelectField
                  fieldName="first_language"
                  label="First language"
                  control={control}
                  selectOption={firstLanguageOptions}
                  iProps={{ placeholder: "Select language" }}
                  isRequired
                  defaultValue="english"
                  rules={{
                    required: "First language is required.",
                  }}
                  validate={errors.first_language && "error"}
                  validMessage={
                    errors.first_language && errors.first_language.message
                  }
                />
              </Col>
              <Col span={12}>
                <InputField
                  fieldName="email"
                  label="Account email"
                  control={control}
                  defaultValue=""
                  iProps={{
                    placeholder: "Enter email",
                    autoComplete: "account_email",
                    maxLength: 100,
                  }}
                  isRequired
                  rules={{
                    required: "Email is required.",
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Please enter a valid email address.",
                    },
                  }}
                  validate={errors.email && "error"}
                  validMessage={errors.email && errors.email.message}
                  tooltipTitle="This email will be used to create the user’s account in LandScaling."
                />
              </Col>
              <Col span={12}>
                <InputPhone fieldName="phone" label="Phone" control={control} />
              </Col>
              <Col span={12} className="mb-0">
                <DateField
                  fieldName="joined_date"
                  label="Joined company"
                  control={control}
                />
              </Col>
              <Col span={12} className="mb-0">
                <DateField
                  fieldName="birthday"
                  label="Birthdate"
                  control={control}
                />
              </Col>
            </Row>
          </Card>
        </Col>
        <div className="fixed_btm_card">
          <Card>
            <div className="centered">
              <Button
                htmlType="button"
                className="outlined-btn"
                onClick={() => navigate("/customer-users")}
              >
                Cancel
              </Button>
              <div style={{ display: "flex", gap: "16px" }}>
                <Button
                  htmlType="button"
                  className="outlined-btn"
                  type="primary"
                  onClick={saveAddMore}
                >
                  Save & add one more
                </Button>
                <Button htmlType="submit" type="primary" className="mint-btn">
                  Save & close
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </Form>
    </FullPageLayout>
  );
}
